var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"md-body-1\">\n<standard-grid data=\"vm.profiles\" class=\"user-grid\" flex=\"\" criteria=\"vm.criteria\" criteria-changed=\"vm.criteriaChanged(args)\" row-selection=\"true\" on-row-select=\"vm.onRowSelect(selectedRow)\" style=\"height: 72vh; width: 99%;\" disable-header=\"false\" disable-add=\"false\" title=\"Users\" on-add=\"vm.onAdd()\">\n<std-column name=\"Username\" field=\"username\" sort min-width=\"30\"></std-column>\n<std-column name=\"First Name\" field=\"firstName\" sort min-width=\"20\"></std-column>\n<std-column name=\"Last Name\" field=\"lastName\" sort min-width=\"10\"></std-column>\n<std-column name=\"Active\" field=\"isEnabled\" sort min-width=\"10\">\n<cell-template>\n<div class=\"ui-grid-cell-contents\">\n{{ MODEL_COL_FIELD?'Active':'Inactive' }}\n</div>\n</cell-template>\n</std-column>\n</standard-grid>\n</div>\n";
var id1="admin/users/users-grid.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/admin/users/users-grid.html
// module id = 642
// module chunks = 0